export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_34.2c1ec543.jpg";